import type { RouteRecordRaw } from 'vue-router'

const platformRoutes: RouteRecordRaw = {
  path: '/:lang?/trading-platforms',
  props: (route) => ({ lang: route.params.lang || 'en' }),
  component: () => import('@/Platform/layouts/DefaultLayout.vue'),
  children: [
    {
      path: '',
      name: 'platform',
      component: () => import('@/Platform/views/MobileTradingApp.vue'),
      meta: {
        breadcrumbLabel: { parent: 'Platforms', child: '_Hantec Mobile trading app' }
      }
    },
    {
      path: 'hantec-markets-mobile-app/',
      name: 'platformMobile',
      meta: {
        breadcrumbLabel: { parent: 'Platforms', child: '_Hantec Mobile trading app' }
      },
      component: () => import('@/Platform/views/MobileTradingApp.vue')
    },
    {
      path: 'hantec-social/',
      name: 'platformSocial',
      meta: {
        breadcrumbLabel: { parent: 'Platforms', child: '_Hantec Social copy trading' }
      },
      component: () => import('@/Platform/views/HantecSocialView.vue')
    },
    {
      path: 'mt4-trading-platform/',
      name: 'platformMT4',
      meta: {
        breadcrumbLabel: { parent: 'Platforms', child: 'MetaTrader 4® (MT4)' }
      },
      component: () => import('@/Platform/views/MetaTrader4View.vue')
    },
    {
      path: 'metatrader-5/',
      name: 'platformMT5',
      meta: {
        breadcrumbLabel: { parent: 'Platforms', child: 'MetaTrader 5® (MT5)' }
      },
      component: () => import('@/Platform/views/MetaTrader5View.vue')
    },
    {
      path: 'client-portal/',
      name: 'clientPortal',
      meta: {
        breadcrumbLabel: { parent: 'Platforms', child: 'Client portal' }
      },
      component: () => import('@/Platform/views/ClientPortalView.vue')
    },
    {
      path: 'hantec-markets-web-trader/',
      name: 'hantecWebTrader',
      meta: {
        breadcrumbLabel: { parent: 'Platforms', child: 'Hantec Web Trader' }
      },
      component: () => import('@/Platform/views/HantecWebTraderView.vue')
    }
  ]
}

export default platformRoutes
